import React from 'react';

import Card from './Card/Card';
import css from './Pools.module.scss';
type PoolsProps = {
    solidarityPoolsList: any[];
};
const Pools = ({ solidarityPoolsList }: PoolsProps) => {
    return (
        <div className={css.pools_container}>
            <div className={css.shadow_inset_white}>
                <div className={css.pools_container__grid_container}>
                    {solidarityPoolsList.map((pool, id) => (
                        <Card key={id} pool={pool} />
                    ))}
                </div>
            </div>
        </div>
    );
};
export default Pools;
